import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { StorefrontLayout } from "@/components/storefront/Layout";
import { Tag } from "lucide-react";
import { ProductListing } from "@/components/storefront/ProductListing";
import { PlayfulPageHeader } from "@/components/storefront/PlayfulPageHeader";
import { PlayfulError, PlayfulNotFound } from "@/components/storefront/PlayfulError";
import { listingSearchSchema } from "@/lib/listing-search";
import { ChristmasStrip } from "@/components/storefront/ChristmasStrip";

export const Route = createFileRoute("/offers")({
  validateSearch: listingSearchSchema,
  head: () => ({
    meta: [
      { property: "og:url", content: "https://mrpanda.gr/offers" },
      { title: "Προσφορές — MrPanda.gr" },
      { name: "description", content: "Ανακάλυψε όλες τις προσφορές του MrPanda.gr: εκπτώσεις σε παιχνίδια, είδη σπιτιού, εποχιακά και πολλά ακόμη με χαμηλές τιμές και γρήγορη αποστολή." },
      { property: "og:title", content: "Προσφορές — MrPanda.gr" },
      { property: "og:description", content: "Ανακάλυψε όλες τις προσφορές του MrPanda.gr με εκπτώσεις σε χιλιάδες προϊόντα." },
    ],
    links: [{ rel: "canonical", href: "https://mrpanda.gr/offers" }],
  }),
  component: OffersPage,
  errorComponent: ({ error, reset }) => (
    <StorefrontLayout>
      <PlayfulError error={error instanceof Error ? error : new Error(String(error))} reset={reset} />
    </StorefrontLayout>
  ),
  notFoundComponent: () => (
    <StorefrontLayout>
      <PlayfulNotFound />
    </StorefrontLayout>
  ),
});

function OffersPage() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <StorefrontLayout>
      <div className="mx-auto max-w-none px-4 pb-10 pt-6">
        <PlayfulPageHeader
          icon={Tag}
          title="Προσφορές"
          subtitle="Τσίμπα τις καλύτερες τιμές πριν εξαφανιστούν! 🐼"
          mascot="🎄"
          doodles={["🎁", "✨", "❄️", "🕯️"]}
          gradient="bg-gradient-to-br from-rose-200/60 via-accent/40 to-background"
        />
        <ChristmasStrip className="px-0 pb-4 pt-0" />
        <ProductListing
          scope={{ mode: "offers", cacheKey: "offers" }}
          search={search}
          onChange={(next) => navigate({ search: (prev: typeof search) => ({ ...prev, ...next }), replace: true })}
        />
      </div>
    </StorefrontLayout>
  );
}
